<template>
    <div>
        <resultFilter @searchForm="getSearchForm" :newtime="newtime"></resultFilter>
        <div class="overview-wrap">
            <div class="overview-title">项目概览</div>
            <div class="card-list">
                <div class="card-item">
                    <div class="card-item-name">竣工体验间</div>
                    <div class="card-item-count">{{NumData.room}}</div>
                </div>
                <div class="card-item">
                    <div class="card-item-name">体验人次</div>
                    <div class="card-item-count">{{NumData.user_all}}</div>
                </div>
                 <!-- <div class="card-item">
                    <div class="card-item-name">体验场次</div>
                    <div class="card-item-count">{{NumData.count}}</div>
                </div> -->
                <div class="card-item">
                    <div class="card-item-name">成交单数</div>
                    <div class="card-item-count">{{NumData.contract2}}</div>
                </div>
            </div>

            <!-- <div class="cycle-wrap">
                <div v-for="(item, index) in dateList" :key="index" :class="['cycle-item', index === curDate && 'cycle-item-act']" @click="changeSelectDate(index)">{{ item }}</div>
            </div> -->
<!--            <div class="exper_list">-->
<!--                <div :class="[index == nNavIndex?'atv_item':'']" v-for="(item,index) in arrNav" :key="index" @click="getNavTo(item,index)">{{item.name}}</div>-->
<!--            </div>-->

            <!-- <van-calendar allow-same-day :min-date="new Date('2020-01-01')" :max-date="new Date()" color="#318544" v-model="show" type="range" @confirm="onConfirm" /> -->
<!--            <transition name="fade-transform" mode="out-in">-->
<!--                <router-view @showOther="showOther"></router-view>-->
<!--            </transition>-->
            <operate></operate>
        </div>
    </div>
</template>

<script>
import resultFilter from "@/components/hvac/performance/project/resultfilter.vue";
import { P } from "@antv/g2plot";
import resultRequest from '@/js/hvac/performance/result.js'
import { fetchVerifyAuthForB} from '@/libsV2/havc.js';
import common from "@/common/common";
import operate from './operate'

export default {
    components: {
        resultFilter,
        operate
    },
    data() {
        return {
            curDate: null,
            nNavIndex: 0,
            dateList: ["昨天", "7天", "30天", "自定义"],
            arrNav: [
                { name: "运营情况", path: "/performance/result/operate" },
                { name: "建设情况", path: "/performance/result/construct" },
            ],
            start_at:'',
            end_at:'',
            time_type: 0,
            compare_type: 0,
            NumData:{},
            show:false,
            currentdate:{},
            newtime: true,   // 改变组件中的时间控件
        };
    },
    created() {
        fetchVerifyAuthForB(() => {
            let sPath = this.$route.path;
            this.arrNav.forEach((item, index) => {
                if (item.path == sPath) {
                    this.nNavIndex = index;
                }
            });
            this.arrNav.indexOf(sPath);

            //  const options = {
            //     // start_at: this.start_at,
            //     // end_at: this.end_at,
            //     start_at: common.getday(common.getDate(), -365),
            //     end_at: common.getDate(),
            //     time_type: this.time_type,
            //     compare_type: this.compare_type
            // }

            // this.getReportStatistics(options)
        })
    },
    methods: {
        showOther() {
            this.nNavIndex = 2;
            this.$router.replace({ path: "/performance/result/construct" });
        },
        getNavTo(item,num) {
            this.nNavIndex = num;
            this.$router.replace({ path: item.path });
        },
        // changeSelectDate(num) {
        //     console.log(num,  this.curDate)
        //     if (num == this.curDate && num != 3) {
        //         return;
        //     }
        //     this.curDate = num;
        //     if (num == 0) {
        //         this.currentdate = {start_at:this.newDate(1),
        //             end_at:this.newDate(1),
        //             type:0
        //         }
        //         this.$store.commit("performanceExperience/SaveCurrentData", this.currentdate);
        //     } else if (num == 1) {
        //         this.currentdate = {start_at:this.newDate(7),
        //             end_at:this.newDate(0),
        //             type:1
        //         }
        //         this.$store.commit("performanceExperience/SaveCurrentData", this.currentdate);
        //     } else if (num == 2) {
        //         this.currentdate = {start_at:this.newDate(30),
        //             end_at:this.newDate(0),
        //             type:2
        //         }
        //         this.$store.commit("performanceExperience/SaveCurrentData", this.currentdate);
        //     } else if (num == 3) {
        //         console.log('666999')
        //         this.show= true
        //     }
        // },
        // 选择日期期间触发的函数
        formatDate(date) {
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            month = (month < 10) ? '0' + month : month = month;
            day = (day < 10) ? '0' + day : day = day;
            return year + '-' + month + '-' + day;
        },
        // onConfirm(date) {
        //     const [start, end] = date;
        //     this.show = false;
        //     this.currentdate = {start_at:this.formatDate(start),
        //         end_at:this.formatDate(end)
        //     }
        //     this.$store.commit("performanceExperience/SaveCurrentData", this.currentdate);
        // },
        // 获取洽谈统计数据
        getReportStatistics (options) {
            resultRequest.getReportStatistics(options).then( res => {
                const result = res.data.data.result
                 this.NumData = {
                    count: result.count,
                    room: result.room,
                    user: result.user,
                    user_all: result.user_all,
                     contract2:result.contract,
                    contract: isFinite(result.contract/result.count) ? ((result.contract/result.count*100) .toFixed(2)) + '%' : '0.00%'
                    // contract: isFinite(result.contract/result.user) ? ((result.contract/result.user).toFixed(2) * 100).toFixed(2) + '%' : '0.00%'
                }
                if (result.contract == 0 ) {
                    this.NumData.contract = '0%'
                }
                console.log(result,'这个是洽谈数据统计请求');
            })
        },
        newDate(i) {
            const nowdate = Date.parse(new Date())
            let newDate = new Date(nowdate - 60*60*24*1000*i);
            const year = newDate.getFullYear();
            let month = newDate.getMonth() + 1;
            let date = newDate.getDate();
            month = (month < 10) ? '0' + month : month
            date = (date < 10) ? '0' + date : date
            const time = year + '-' + month + '-' + date
            return time
        },
        getSearchForm(value) {
            console.log(value,'value')
            this.currentdate = {
                start_at: value.start,   // 开始时间
                end_at: value.end,       // 结束时间
                search_platform: value.agent,      // 代理商
                search_area: value.area, // 大区
                search_source: value.channel,   // 渠道来源
                search_city: value.city,      // 城市
                search_sign: value.worker       //  负责人id
            }

            this.getReportStatistics(this.currentdate);
            this.$store.commit("performanceExperience/SaveCurrentData", this.currentdate);
        }
    },
};
</script>

<style lang="scss" scoped>
.fade-transform-leave-active,
.fade-transform-enter-active {
    transition: all 0.4s;
}
.fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
}
.fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
}
.exper_list {
    width: 100%;
    padding: 32px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    div {
        width: 50%;
        text-align: center;
        font-size: 28px;
        color: #a2a2a2;
        display: flex;
        flex-direction: column;
    }
    .atv_item {
        color: #318544;
        align-items: center;
        &::after {
            content: "";
            display: flex;
            margin-top: 4px;
            width: 112px;
            height: 4px;
            background: #318544;
        }
    }
}
.cycle-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;

    .cycle-item {
        width: 21.7%;
        border-radius: 12px;
        border: 2px solid #dbdbdb;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        text-align: center;
        color: #444444;
        line-height: 60px;
    }

    .cycle-item-act {
        border-color: #318544;
        color: #318544;
    }
}
/*公共样式*/
.overview-title {
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #222222;
    line-height: 40px;
}
.overview-wrap {
    width: 93.6%;
    margin: 20px auto 24px;
    background: #fff;
    padding: 28px 24px 32px;
    border-radius: 12px;

    .card-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 24px 0;

        .card-item {
            width: 31%;
            height: 200px;
            background: #f7f7f7;
            border-radius: 16px;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;

            .card-item-name {
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #858585;
                line-height: 40px;
            }

            .card-item-count {
                font-size: 48px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #318544;
                line-height: 66px;
            }
        }
    }

    .check-more {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        text-align: center;
        color: #444444;
        line-height: 34px;
    }
}

.van-calendar {
    height: 81% !important;
}
.van-calendar__popup.van-popup--bottom, .van-calendar__popup.van-popup--top{
    height: 81% !important;
}
::v-deep .van-calendar__bottom-info {
    letter-spacing: 1px;
}

</style>
